import { render, staticRenderFns } from "./VInventoryBatchModal.vue?vue&type=template&id=13778bea"
import script from "./VInventoryBatchModal.vue?vue&type=script&lang=js"
export * from "./VInventoryBatchModal.vue?vue&type=script&lang=js"
import style0 from "./VInventoryBatchModal.vue?vue&type=style&index=0&id=13778bea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports